import { render } from "./index.vue?vue&type=template&id=9cc27c52"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/componentBase/BaseRichText/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9cc27c52"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9cc27c52', __exports__)) {
    api.reload('9cc27c52', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=9cc27c52", () => {
    api.rerender('9cc27c52', render)
  })

}


export default __exports__